import React from "react";
import CopyrightFooter from "../../components/footer/employers/CopyrightFooter";
import DashboardEmployerSidebar from "../../components/header/DashboardSidebar";
import DashboardHeader from "../../components/header/DashboardHeader";
import MobileMenu from "../../components/header/MobileMenu";

export default function LegacyShell({ children }) {
	return (
		<div className="page-wrapper dashboard">
			<span className="header-span" />
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">{children}</div>
			</section>
			<CopyrightFooter />
		</div>
	);
}
